export default {
  PURCHASES_ORDERS_LIST: "Liste des commandes",
  ADD_PURCHASES_ORDER: "Ajouter une commande",
  ADD_PURCHASES_ORDER_ITEM: "Ajouter une ligne",
  PURCHASES_ORDER_ADDED: "Commande ajoutée",
  OWNER: "Propriétaire",
  EDIT_PURCHASES_ORDER: "Modifier une commande",
  PURCHASES_ORDER_UPDATED: "Commande mise à jour",
  BILLING_ADDRESS: "Adresse de facturation",
  EXPIRATION_TIME: "Date d'expiration",
  ITEM_TYPE: "Type",
  SELECT_PRODUCTS: "Choisir un produit",
  SELECT_SUBSCRIPTIONS: "Choisir une inscription",
  SELECT_PACKAGES: "Choisir un forfait",
  DELETE_PURCHASES_ORDER_ITEM: "Supprimer la ligne",
  UPDATE_PURCHASES_ORDER_ITEM: "Modifier la ligne",
  PURCHASES_ORDER_ITEM_DELETED: "Ligne supprimée",
  PURCHASES_ORDER_ITEM_ADDED: "Ligne ajoutée",
  PURCHASES_ORDER_ITEM_EDITED: "Ligne modifiée",
  SEND: "Envoyer",
  CANCEL: "Annuler",
  REFUND: "Rembourser",
  ADD_PAYMENT: "Ajouter un paiement",
  PURCHASES_ORDER_SENT: "Commande envoyée",
  SELECT_USERS: "Choisir l'utilisateur",
  SELECT_CUSTOMERS: "Choisir le client",
  SELECT_ORGANIZATIONS: "Choisir l'organisation",
  SELECT_SUPPLIERS: "Choisir le fournisseur",
  DELETE_THIS_PURCHASES_ORDER: "Supprimer cette commande ?",
  PURCHASES_ORDER_DELETED: "Commande supprimée",
  CANCEL_PURCHASES_ORDER_QUESTION: "Annuler la commande ?",
  CANCEL_PURCHASES_ORDER_WARNING:
    "Si vous annulez cette commande, elle sera irrécupérable et ne sera pas visible dans le rapport hebdomadaire.",
  PURCHASES_ORDER_CANCELED: "Commande annulée",
  RECIPIENT: "Destinataire",
  ISSUER: "Émetteur",
  VALIDATE: "Valider la commande",
  PURCHASES_ORDER_VALIDATED: "Commande validée",
  SEND_NOW_QUESTION: "Envoyer la commande maintenant ?",
  SEND_NOW_HINT: "Vous pouvez envoyer la commande au fournisseur dès maintenant pour éviter les oublis.",
  SENT_BY: "Envoyée par",
  SENT_TO: "Envoyée à",
  SENT_AT: "Envoyée le",
  TO: "À",
  CC: "Cc",
  BCC: "Cci",
  VALIDATE_DELIVERY_DATE_TITLE: "Valider la commande",
  SELECT_EXPECTED_DELIVERY_DATE: "Sélectionner une date de livraison prévue",
  NO_ALLOWED_DELIVERY_DATES:
    "Aucune date de livraison prévue n'est disponible selon les règles d'approvisionnement. La commande peut être validée sans date prévue.",
  GENERATE_INVOICE: "Créer la facture",
  INVOICE_GENERATED: "Facture créée",
  VIEW_INVOICE: "Voir la facture",
  ADD_DELIVERY: "Ajouter une réception",
  DELIVERIES_STATE: "État de livraison",
  DELIVERIES_STATE_ITEM: "Produit",
  DELIVERIES_STATE_ORDERED_QUANTITY: "Quantité commandée",
  DELIVERIES_STATE_DELIVERED_QUANTITY: "Quantité livrée",
  DELIVERIES_STATE_REMAINING_QUANTITY: "Quantité restante",
  NOT_INVOICED: "À facturer",
  NOT_DELIVERED: "À livrer",
  DELIVERED: "Livré",
  PURCHASES_INVOICES: "Factures achat",
  ADD_INVOICE: "Confirmer la réception",
  INVOICING_TYPE: "Type de facturation",
  INVOICING_TYPE_COMPLETE: "Complète",
  INVOICING_TYPE_AMOUNT: "Montant",
  INVOICING_TYPE_PRODUCT: "Produit",
  INVOICING_STATUS_PENDING: "Non Facturée",
  INVOICING_STATUS_PARTIALLY_INVOICED: "Partiellement facturée",
  INVOICING_STATUS_INVOICED: "Facturée",
  DELIVERY_STATUS_PENDING: "Non Livrée",
  DELIVERY_STATUS_PARTIALLY_DELIVERED: "Partiellement livrée",
  DELIVERY_STATUS_DELIVERED: "Livrée",
  INVOICING_STATUS: "Statut de facturation",
  DEPOSITS: "Consignes",
  CHARGE_NOT_TAXABLE: "Non taxable",
  TRANSPORTATION_FEES: "Frais de transport / carburant",
  CHARGES: "Frais",
  OTHER_CHARGES: "Autres frais",
  NO_TAXES: "Non taxable",
  TAXES_TPS_TVQ: "Taxable",
  ORDER_STATUS_DRAFT: "Brouillon",
  ORDER_STATUS_CANCELED: "Annulée",
  ORDER_STATUS_VALIDATED: "Validée",
  ORDER_STATUS_COMPLETED: "Complétée",
  DELIVERY_STATUS: "Statut de livraison",
  INVOICE_TYPE: "Type de facture",
  INVOICE_TYPE_DOWNPAYMENT: "Facture d'acompte",
  INVOICE_TYPE_STANDARD: "Facture standard",
  EXCLUDING_TAXES: "Commande sans taxes",
  PURCHASES_ORDER_DELIVERY_ADDED: "Livraison de commande d'achat ajoutée",
  PURCHASES_ORDER_INVOICE_ADDED: "Facture de commande d'achat ajoutée",
  REVERT_TO_DRAFT: "Remettre en brouillon",
  CONFIRM_REVERT_TO_DRAFT: "Êtes-vous sûr de vouloir remettre en brouillon",
  PURCHASES_ORDER_REVERTED: "Commande remise en brouillon",
  WITHOUT_TAXES: "Montant sans taxes",
  ADVANCED_MODE: "Mode avancé",
  SHOW_CHECKED: "Afficher traités",
  SHOW_UNCHECKED: "Afficher non traités",
  SHOW_ONLY_WITH_TAXES: "Avec taxes seulement",
  SET_ALL_QUANTITIES_TO_ZERO: "Mettre tout à zéro",
};
